// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.utility-nav {
  max-width: 180px;
}

nav.navbar-subsite {
  min-height: 0px;
}

.additional-nav {
  background-color: #0b2d71; /* Primary background color */
  padding: 0px 0;
}
.additional-nav .nav {
  display: flex;
  justify-content: center; /* Center the items horizontally */
  align-items: center; /* Align items vertically */
  flex-wrap: nowrap; /* Prevent wrapping to the next line */
}
.additional-nav .nav .nav-item {
  margin: 0; /* Remove margin to avoid spacing issues */
}
.additional-nav .nav .nav-item .nav-link {
  color: #ffffff; /* White text */
  font-family: "Gotham", sans-serif;
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  padding: 10px 15px; /* Consistent padding */
  transition: background-color 0.3s ease, color 0.3s ease;
}
.additional-nav .nav .nav-item .nav-link:hover {
  background-color: #0066b2; /* Hover background color */
  color: #ffffff; /* Ensure white text on hover */
}
.additional-nav .nav .dropdown-item {
  background-color: #0b2d71; /* White text */
  color: #ffffff; /* Ensure white text on hover */
  font-family: "Gotham", sans-serif;
  font-size: 12px;
  font-weight: bold;
  margin: 0; /* Remove margin to avoid spacing issues */
  text-decoration: none;
  padding: 10px 15px; /* Consistent padding */
  transition: background-color 0.3s ease, color 0.3s ease;
  border-radius: 0%;
}
.additional-nav .nav .dropdown-item:hover {
  background-color: #0066b2; /* Hover background color */
  color: #ffffff; /* Ensure white text on hover */
}
.additional-nav .dropdown-submenu {
  position: relative;
}
.additional-nav .dropdown-submenu .dropdown-menu {
  top: 0;
  left: 100%;
  margin-top: -6px;
  margin-left: 0;
  background-color: #0b2d71 !important;
  border: none;
  min-width: 180px;
}`, "",{"version":3,"sources":["webpack://./src/app/header/header.component.scss"],"names":[],"mappings":"AAAA;EAEE,gBAAA;AAAF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,yBAAA,EAAA,6BAAA;EACA,cAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA,EAAA,kCAAA;EACA,mBAAA,EAAA,2BAAA;EACA,iBAAA,EAAA,sCAAA;AADJ;AAGI;EACE,SAAA,EAAA,0CAAA;AADN;AAGM;EACE,cAAA,EAAA,eAAA;EACA,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA,EAAA,uBAAA;EACA,uDAAA;AADR;AAGQ;EACE,yBAAA,EAAA,2BAAA;EACA,cAAA,EAAA,+BAAA;AADV;AAOI;EACE,yBAAA,EAAA,eAAA;EACC,cAAA,EAAA,+BAAA;EACD,iCAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA,EAAA,0CAAA;EACC,qBAAA;EACD,kBAAA,EAAA,uBAAA;EACA,uDAAA;EACA,iBAAA;AALN;AAOM;EACE,yBAAA,EAAA,2BAAA;EACA,cAAA,EAAA,+BAAA;AALR;AAUE;EACE,kBAAA;AARJ;AAUK;EACC,MAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;AARN","sourcesContent":["div.utility-nav {\r\n\r\n  max-width: 180px;\r\n\r\n}\r\n\r\nnav.navbar-subsite {\r\n  min-height: 0px;\r\n}\r\n\r\n.additional-nav {\r\n  background-color: #0b2d71; /* Primary background color */\r\n  padding: 0px 0;\r\n\r\n  .nav {\r\n    display: flex;\r\n    justify-content: center; /* Center the items horizontally */\r\n    align-items: center; /* Align items vertically */\r\n    flex-wrap: nowrap; /* Prevent wrapping to the next line */\r\n\r\n    .nav-item {\r\n      margin: 0; /* Remove margin to avoid spacing issues */\r\n\r\n      .nav-link {\r\n        color: #ffffff; /* White text */\r\n        font-family: 'Gotham', sans-serif;\r\n        font-size: 12px;\r\n        font-weight: bold;\r\n        text-decoration: none;\r\n        padding: 10px 15px; /* Consistent padding */\r\n        transition: background-color 0.3s ease, color 0.3s ease;\r\n\r\n        &:hover {\r\n          background-color: #0066b2; /* Hover background color */\r\n          color: #ffffff; /* Ensure white text on hover */\r\n        }\r\n      }\r\n    }\r\n\r\n\r\n    .dropdown-item {\r\n      background-color:  #0b2d71;; /* White text */\r\n       color: #ffffff; /* Ensure white text on hover */\r\n      font-family: 'Gotham', sans-serif;\r\n      font-size: 12px;\r\n      font-weight: bold;\r\n      margin: 0; /* Remove margin to avoid spacing issues */\r\n       text-decoration: none;\r\n      padding: 10px 15px; /* Consistent padding */\r\n      transition: background-color 0.3s ease, color 0.3s ease;\r\n      border-radius: 0%;\r\n\r\n      &:hover {\r\n        background-color: #0066b2; /* Hover background color */\r\n        color: #ffffff; /* Ensure white text on hover */\r\n      }\r\n    }\r\n  }\r\n\r\n  .dropdown-submenu {\r\n    position: relative;\r\n\r\n     .dropdown-menu {\r\n      top: 0;\r\n      left: 100%;\r\n      margin-top: -6px;\r\n      margin-left: 0;\r\n      background-color: #0b2d71 !important;\r\n      border: none;\r\n      min-width: 180px;\r\n    }\r\n\r\n   \r\n    \r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
